import * as Sentry from '@sentry/vue';
import { isDev } from '@/utils/common';

export default function useSentry(app: any, router: any) {
  if (import.meta.env.VITE_SENTRY === 'true') {
    Sentry.init({
      release: import.meta.env.VITE_SENTRY_RELEASE,
      environment: isDev() ? 'development' : 'production',
      app,
      dsn: 'https://fa034e1750d880b3d83f11d805fa0173@sentry.app.qinsilk.com/17',
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
        // new Sentry.Replay(),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
  }
}
